import { render, staticRenderFns } from "./pedidoCreado.vue?vue&type=template&id=aac008d8&"
import script from "./pedidoCreado.vue?vue&type=script&lang=js&"
export * from "./pedidoCreado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports